const NODE_ENV = process.env.NODE_ENV as string
export default function isDevEnvironment(): boolean {
	return ['development', 'test', 'owsdev'].includes(NODE_ENV)
}
